var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWkndhrs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 165.16 65.33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n        stroke-width: 0px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,0l15.57,40.93h26.33l7.88-23.44h.19l6.73,23.44h27.48L99.76,0h-23.49l-7.29,24.6h-.19L61.49,0h-23.37l-7.19,24.6h-.19L23.44,0H0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M102.81.77l-15.57,40.55,20.37,7.88,5.57-14.6,21.71,8.46-5.57,14.41,20.37,7.88,15.47-40.6-20.27-7.82-5.19,13.26-21.71-8.26,5.19-13.45L102.81.77Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWkndhrs);
export default __webpack_public_path__ + "static/media/wkndhrs.f715f8bb3ce9861ec2580e250547b6db.svg";
export { ForwardRef as ReactComponent };